import * as React from 'react'
import { Lazy, M, O, pipe, v } from '@packages/prelude'
import { createRoot } from 'react-dom/client'

export const monoid: M.Monoid<React.JSX.Element> = {
  concat: (x, y) => (
    <>
      {x}
      {y}
    </>
  ),
  empty: <></>
}

export function mount(elem: HTMLElement | null, factory: Lazy<React.JSX.Element>) {
  pipe(
    elem,
    O.fromNullable,
    O.map(createRoot),
    O.foldMap(v.Monoid)(root => {
      root.render(factory())
    })
  )
}

export const mountTo = (factory: Lazy<React.JSX.Element>) => (elem: Element) => {
  createRoot(elem).render(factory())
}
